<script>
// const ajaxUrl = 'http://www.xyz.com/'; // 暂时君宝那里的ip和端口号
// const ajaxUrl = 'http://test.hcs55.com:8099/'; // 测试环境

import axios from 'axios'
import $ from 'jquery'

// const ajaxUrl = 'https://user.hcfx.com/'; // 线上版本
const ajaxUrl = location.protocol + '//' + location.host // 统一接口请求
const options = [
  { area: 'China', code: '+86', reg: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/ },
  {
    area: 'Hong Kong, China',
    code: '+852',
    // reg: /^0{0,1}[1,4,5,6,7,8,9](?:\d{7}|\d{8}|\d{12})$/
    reg: /^[56789]\d{7}$/
  },
  {
    area: 'Taiwan, China',
    code: '+886',
    reg: /^0{0,1}[6,7,9](?:\d{7}|\d{8}|\d{10})$/
  },
  { area: 'Afghanistan', code: '+93', reg: /^\d{6,15}$/ },
  { area: 'Albania (Shqipëri)', code: '+355', reg: /^\d{6,15}$/ },
  { area: 'Algeria', code: '+213', reg: /^\d{6,15}$/ },
  { area: 'Aland Islands', code: '+358', reg: /^\d{6,15}$/ },
  { area: 'American Samoa', code: '+1684', reg: /^\d{6,15}$/ },
  { area: 'Andorra', code: '+376', reg: /^\d{6,15}$/ },
  { area: 'Angola', code: '+244', reg: /^\d{6,15}$/ },
  { area: 'Anguilla', code: '+1264', reg: /^\d{6,15}$/ },
  { area: 'Antigua and Barbuda', code: '+1268', reg: /^\d{6,15}$/ },
  { area: 'Argentina', code: '+54', reg: /^\d{6,12}$/ },
  { area: 'Armenia (Հայաստան)', code: '+374', reg: /^\d{6,15}$/ },
  { area: 'Aruba', code: '+297', reg: /^\d{6,15}$/ },
  { area: 'Australia', code: '+61', reg: /^4\d{8,9}$/ },
  { area: 'Austria (Österreich)', code: '+43', reg: /^\d{6,12}$/ },
  { area: 'Azerbaijan (Azərbaycan)', code: '+994', reg: /^\d{6,15}$/ },
  { area: 'Bahamas', code: '+1242', reg: /^\d{6,12}$/ },
  { area: 'Bahrain', code: '+973', reg: /^\d{6,15}$/ },
  { area: 'Bangladesh', code: '+880', reg: /^\d{6,15}$/ },
  { area: 'Barbados', code: '+1246', reg: /^\d{6,15}$/ },
  { area: 'Belarus (Беларусь)', code: '+375', reg: /^\d{6,12}$/ },
  { area: 'Belgium (België)', code: '+32', reg: /^\d{6,12}$/ },
  { area: 'Belize', code: '+501', reg: /^\d{6,12}$/ },
  { area: 'Benin (Bénin)', code: '+229', reg: /^\d{6,15}$/ },
  { area: 'Bermuda', code: '+1441', reg: /^\d{6,15}$/ },
  { area: 'Bhutan', code: '+975', reg: /^\d{6,15}$/ },
  { area: 'Bolivia', code: '+591', reg: /^\d{6,15}$/ },
  { area: 'Bosnia and Herzegovina', code: '+387', reg: /^\d{6,15}$/ },
  { area: 'Botswana', code: '+267', reg: /^\d{6,15}$/ },
  { area: 'Brazil (Brasil)', code: '+55', reg: /^\d{6,12}$/ },
  { area: 'British Indian Ocean Territory', code: '+246', reg: /^\d{6,15}$/ },
  { area: 'British Virgin Islands', code: '+1284', reg: /^\d{6,12}$/ },
  { area: 'Brunei', code: '+673', reg: /^\d{6,15}$/ },
  { area: 'Bulgaria (България)', code: '+359', reg: /^\d{6,12}$/ },
  { area: 'Burkina Faso', code: '+226', reg: /^\d{6,15}$/ },
  { area: 'Burundi (Uburundi)', code: '+257', reg: /^\d{6,15}$/ },
  { area: 'Cambodia', code: '+855', reg: /^\d{6,12}$/ },
  { area: 'Cameroon (Cameroun)', code: '+237', reg: /^\d{6,15}$/ },
  { area: 'Canada', code: '+1', reg: /^\d{10}$/ },
  { area: 'Cape Verde (Kabu Verdi)', code: '+238', reg: /^\d{6,15}$/ },
  { area: 'Caribbean Netherlands', code: '+599', reg: /^\d{6,15}$/ },
  { area: 'Cayman Islands', code: '+1345', reg: /^\d{6,15}$/ },
  {
    area: 'Central African Republic (République centrafricaine)',
    code: '+236',
    reg: /^\d{6,15}$/
  },
  { area: 'Chad (Tchad)', code: '+235', reg: /^\d{6,15}$/ },
  { area: 'Chile', code: '+56', reg: /^\d{6,12}$/ },
  { area: 'Christmas Island', code: '+61', reg: /^4\d{8,9}$/ },
  { area: 'Cocos (Keeling) Islands', code: '+61', reg: /^4\d{8,9}$/ },
  { area: 'Colombia', code: '+57', reg: /^\d{6,12}$/ },
  { area: 'Comoros', code: '+269', reg: /^\d{6,15}$/ },
  {
    area: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    code: '+243',
    reg: /^\d{6,15}$/
  },
  {
    area: 'Congo (Republic) (Congo-Brazzaville)',
    code: '+242',
    reg: /^\d{6,15}$/
  },
  { area: 'Cook Islands', code: '+682', reg: /^\d{6,15}$/ },
  { area: 'Costa Rica', code: '+506', reg: /^\d{6,15}$/ },
  { area: 'Côte d’Ivoire', code: '+225', reg: /^\d{6,15}$/ },
  { area: 'Croatia (Hrvatska)', code: '+385', reg: /^\d{6,15}$/ },
  { area: 'Cuba', code: '+53', reg: /^\d{6,15}$/ },
  { area: 'Curaçao', code: '+599', reg: /^\d{6,15}$/ },
  { area: 'Cyprus (Κύπρος)', code: '+357', reg: /^\d{6,15}$/ },
  { area: 'Czech Republic (Česká republika)', code: '+420', reg: /^\d{6,15}$/ },
  { area: 'Denmark (Danmark)', code: '+45', reg: /^\d{6,12}$/ },
  { area: 'Djibouti', code: '+253', reg: /^\d{6,15}$/ },
  { area: 'Dominica', code: '+1767', reg: /^\d{6,15}$/ },
  {
    area: 'Dominican Republic (República Dominicana)',
    code: '+1',
    reg: /^\d{10}$/
  },
  { area: 'Ecuador', code: '+593', reg: /^\d{6,15}$/ },
  { area: 'Egypt', code: '+20', reg: /^\d{6,12}$/ },
  { area: 'El Salvador', code: '+503', reg: /^\d{6,15}$/ },
  {
    area: 'Equatorial Guinea (Guinea Ecuatorial)',
    code: '+240',
    reg: /^\d{6,15}$/
  },
  { area: 'Eritrea', code: '+291', reg: /^\d{6,15}$/ },
  { area: 'Estonia (Eesti)', code: '+372', reg: /^\d{6,12}$/ },
  { area: 'Ethiopia', code: '+251', reg: /^\d{9,10}$/ },
  {
    area: 'Falkland Islands (Islas Malvinas)',
    code: '+500',
    reg: /^\d{6,15}$/
  },
  { area: 'Faroe Islands (Føroyar)', code: '+298', reg: /^\d{6,15}$/ },
  { area: 'Fiji', code: '+679', reg: /^\d{6,15}$/ },
  { area: 'Finland (Suomi)', code: '+358', reg: /^\d{6,12}$/ },
  { area: 'France', code: '+33', reg: /^(\d{6}|\d{8,9})$/ },
  { area: 'French Guiana (Guyane française)', code: '+594', reg: /^\d{6,15}$/ },
  {
    area: 'French Polynesia (Polynésie française)',
    code: '+689',
    reg: /^\d{6,15}$/
  },
  { area: 'Gabon', code: '+241', reg: /^\d{6,15}$/ },
  { area: 'Gambia', code: '+220', reg: /^\d{6,15}$/ },
  { area: 'Georgia (საქართველო)', code: '+995', reg: /^\d{6,15}$/ },
  { area: 'Germany (Deutschland)', code: '+49', reg: /^1(\d{5,6}|\d{9,12})$/ },
  { area: 'Ghana (Gaana)', code: '+233', reg: /^\d{6,15}$/ },
  { area: 'Gibraltar', code: '+350', reg: /^\d{6,15}$/ },
  { area: 'Greece (Ελλάδα)', code: '+30', reg: /^\d{6,12}$/ },
  { area: 'Greenland (Kalaallit Nunaat)', code: '+299', reg: /^\d{6,15}$/ },
  { area: 'Grenada', code: '+1473', reg: /^\d{6,15}$/ },
  { area: 'Guadeloupe', code: '+590', reg: /^\d{6,15}$/ },
  { area: 'Guam', code: '+1671', reg: /^\d{6,15}$/ },
  { area: 'Guatemala', code: '+502', reg: /^\d{6,15}$/ },
  { area: 'Guernsey', code: '+44', reg: /^\d{6,15}$/ },
  { area: 'Guinea (Guinée)', code: '+224', reg: /^\d{6,15}$/ },
  { area: 'Guinea-Bissau (Guiné Bissau)', code: '+245', reg: /^\d{6,15}$/ },
  { area: 'Guyana', code: '+592', reg: /^\d{6,15}$/ },
  { area: 'Haiti', code: '+509', reg: /^\d{6,15}$/ },
  { area: 'Honduras', code: '+504', reg: /^\d{6,15}$/ },
  { area: 'Hungary (Magyarország)', code: '+36', reg: /^\d{6,12}$/ },
  { area: 'Iceland (Ísland)', code: '+354', reg: /^\d{6,8}$/ },
  { area: 'India', code: '+91', reg: /^\d{6,12}$/ },
  { area: 'Indonesia', code: '+62', reg: /^[2-9]\d{7,11}$/ },
  { area: 'Iran', code: '+98', reg: /^\d{6,15}$/ },
  { area: 'Iraq', code: '+964', reg: /^\d{6,15}$/ },
  { area: 'Ireland', code: '+353', reg: /^\d{6,12}$/ },
  { area: 'Isle of Man', code: '+44', reg: /^[347-9](\d{8,9}|\d{11,12})$/ },
  { area: 'Israel', code: '+972', reg: /^\d{6,12}$/ },
  { area: 'Italy (Italia)', code: '+39', reg: /^[37]\d{8,11}$/ },
  { area: 'Jamaica', code: '+1876', reg: /^\d{6,15}$/ },
  { area: 'Japan (日本)', code: '+81', reg: /^0[7,8,9]0(\d{8})$/ },
  { area: 'Jersey', code: '+44', reg: /^[347-9](\d{8,9}|\d{11,12})$/ },
  { area: 'Jordan', code: '+962', reg: /^\d{6,12}$/ },
  { area: 'Kazakhstan (Казахстан)', code: '+7', reg: /^[13489]\d{9,11}$/ },
  { area: 'Kenya', code: '+254', reg: /^\d{6,15}$/ },
  { area: 'Kiribati', code: '+686', reg: /^\d{6,15}$/ },
  { area: 'Kosovo', code: '+383', reg: /^\d{6,15}$/ },
  { area: 'Kuwait', code: '+965', reg: /^\d{6,15}$/ },
  { area: 'Kyrgyzstan (Кыргызстан)', code: '+996', reg: /^\d{6,12}$/ },
  { area: 'Laos', code: '+856', reg: /^\d{6,15}$/ },
  { area: 'Latvia (Latvija)', code: '+371', reg: /^\d{6,15}$/ },
  { area: 'Lebanon', code: '+961', reg: /^\d{6,15}$/ },
  { area: 'Lesotho', code: '+266', reg: /^\d{6,15}$/ },
  { area: 'Liberia', code: '+231', reg: /^\d{6,15}$/ },
  { area: 'Libya', code: '+218', reg: /^\d{6,15}$/ },
  { area: 'Liechtenstein', code: '+423', reg: /^\d{6,8}$/ },
  { area: 'Lithuania (Lietuva)', code: '+370', reg: /^\d{6,12}$/ },
  { area: 'Luxembourg', code: '+352', reg: /^\d{6,12}$/ },
  { area: 'Macau, China(中国澳門)', code: '+853', reg: /^6\d{7}$/ },
  { area: 'Macedonia (FYROM) (Македонија)', code: '+389', reg: /^\d{6,15}$/ },
  { area: 'Madagascar (Madagasikara)', code: '+261', reg: /^\d{6,15}$/ },
  { area: 'Malawi', code: '+265', reg: /^\d{6,15}$/ },
  { area: 'Malaysia', code: '+60', reg: /^\d{9,10}$/ },
  { area: 'Maldives', code: '+960', reg: /^\d{6,12}$/ },
  { area: 'Mali', code: '+223', reg: /^\d{6,15}$/ },
  { area: 'Malta', code: '+356', reg: /^\d{6,15}$/ },
  { area: 'Marshall Islands', code: '+692', reg: /^\d{6,15}$/ },
  { area: 'Martinique', code: '+596', reg: /^\d{6,15}$/ },
  { area: 'Mauritania', code: '+222', reg: /^\d{6,15}$/ },
  { area: 'Mauritius (Moris)', code: '+230', reg: /^\d{6,15}$/ },
  { area: 'Mayotte', code: '+262', reg: /^\d{6,15}$/ },
  { area: 'Mexico (México)', code: '+52', reg: /^\d{6,12}$/ },
  { area: 'Micronesia', code: '+691', reg: /^\d{6,15}$/ },
  { area: 'Moldova (Republica Moldova)', code: '+373', reg: /^\d{6,15}$/ },
  { area: 'Monaco', code: '+377', reg: /^\d{6,15}$/ },
  { area: 'Mongolia (Монгол)', code: '+976', reg: /^\d{6,12}$/ },
  { area: 'Montenegro (Crna Gora)', code: '+382', reg: /^\d{6,15}$/ },
  { area: 'Montserrat', code: '+1664', reg: /^\d{6,15}$/ },
  { area: 'Morocco', code: '+212', reg: /^\d{6,12}$/ },
  { area: 'Mozambique (Moçambique)', code: '+258', reg: /^\d{6,15}$/ },
  { area: 'Myanmar (Burma)', code: '+95', reg: /^\d{6,15}$/ },
  { area: 'Namibia (Namibië)', code: '+264', reg: /^\d{6,15}$/ },
  { area: 'Nauru', code: '+674', reg: /^\d{6,15}$/ },
  { area: 'Nepal', code: '+977', reg: /^\d{6,15}$/ },
  { area: 'Netherlands (Nederland)', code: '+31', reg: /^6\d{8}$/ },
  {
    area: 'New Caledonia (Nouvelle-Calédonie)',
    code: '+687',
    reg: /^\d{6,15}$/
  },
  { area: 'New Zealand', code: '+64', reg: /^(0){0,1}[278]\d{7,9}$/ },
  { area: 'Nicaragua', code: '+505', reg: /^\d{6,15}$/ },
  { area: 'Niger (Nijar)', code: '+227', reg: /^\d{6,15}$/ },
  { area: 'Nigeria', code: '+234', reg: /^\d{6,12}$/ },
  { area: 'Niue', code: '+683', reg: /^\d{6,15}$/ },
  { area: 'Norfolk Island', code: '+672', reg: /^\d{6,15}$/ },
  {
    area: 'North Korea (조선 민주주의 인민 공화국)',
    code: '+850',
    reg: /^\d{6,15}$/
  },
  { area: 'Northern Mariana Islands', code: '+1670', reg: /^\d{6,15}$/ },
  { area: 'Norway (Norge)', code: '+47', reg: /^\d{6,12}$/ },
  { area: 'Oman', code: '+968', reg: /^\d{6,15}$/ },
  { area: 'Pakistan', code: '+92', reg: /^\d{6,15}$/ },
  { area: 'Palau', code: '+680', reg: /^\d{6,15}$/ },
  { area: 'Palestine', code: '+970', reg: /^\d{6,15}$/ },
  { area: 'Panama (Panamá)', code: '+507', reg: /^\d{6,12}$/ },
  { area: 'Papua New Guinea', code: '+675', reg: /^\d{6,15}$/ },
  { area: 'Paraguay', code: '+595', reg: /^\d{6,15}$/ },
  { area: 'Peru (Perú)', code: '+51', reg: /^\d{6,12}$/ },
  { area: 'Philippines', code: '+63', reg: /^[24579](\d{7,9}|\d{12})$/ },
  { area: 'Poland (Polska)', code: '+48', reg: /^\d{6,12}$/ },
  { area: 'Portugal', code: '+351', reg: /^\d{6,12}$/ },
  { area: 'Puerto Rico', code: '+1', reg: /^\d{10}$/ },
  { area: 'Qatar', code: '+974', reg: /^\d{6,12}$/ },
  { area: 'Réunion (La Réunion)', code: '+262', reg: /^\d{6,15}$/ },
  { area: 'Romania (România)', code: '+40', reg: /^\d{6,12}$/ },
  { area: 'Russia (Россия)', code: '+7', reg: /^[13489]\d{9,11}$/ },
  { area: 'Rwanda', code: '+250', reg: /^\d{6,15}$/ },
  {
    area: 'Saint Barthélemy (Saint-Barthélemy)',
    code: '+590',
    reg: /^\d{6,15}$/
  },
  { area: 'Saint Helena', code: '+290', reg: /^\d{6,15}$/ },
  { area: 'Saint Kitts and Nevis', code: '+1869', reg: /^\d{6,15}$/ },
  { area: 'Saint Lucia', code: '+1758', reg: /^\d{6,15}$/ },
  {
    area: 'Saint Martin (Saint-Martin (partie française))',
    code: '+590',
    reg: /^\d{6,15}$/
  },
  {
    area: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    code: '+508',
    reg: /^\d{6,15}$/
  },
  {
    area: 'Saint Vincent and the Grenadines',
    code: '+1784',
    reg: /^\d{6,15}$/
  },
  { area: 'Samoa', code: '+685', reg: /^\d{6,15}$/ },
  { area: 'San Marino', code: '+378', reg: /^\d{6,15}$/ },
  {
    area: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    code: '+239',
    reg: /^\d{6,15}$/
  },
  { area: 'Saudi Arabia', code: '+966', reg: /^\d{6,12}$/ },
  { area: 'Senegal (Sénégal)', code: '+221', reg: /^\d{6,15}$/ },
  { area: 'Serbia (Србија)', code: '+381', reg: /^\d{6,12}$/ },
  { area: 'Seychelles', code: '+248', reg: /^\d{6,12}$/ },
  { area: 'Sierra Leone', code: '+232', reg: /^\d{6,15}$/ },
  { area: 'Singapore', code: '+65', reg: /^[13689]\d{6,7}$/ },
  { area: 'Sint Maarten', code: '+1721', reg: /^\d{6,15}$/ },
  { area: 'Slovakia (Slovensko)', code: '+421', reg: /^\d{6,15}$/ },
  { area: 'Slovenia (Slovenija)', code: '+386', reg: /^\d{6,15}$/ },
  { area: 'Solomon Islands', code: '+677', reg: /^\d{6,15}$/ },
  { area: 'Somalia (Soomaaliya)', code: '+252', reg: /^\d{6,15}$/ },
  { area: 'South Africa', code: '+27', reg: /^\d{6,12}$/ },
  {
    area: 'South Korea (대한민국)',
    code: '+82',
    reg: /^0{0,1}[7,1](?:\d{8}|\d{9})$/
  },
  { area: 'South Sudan', code: '+211', reg: /^\d{6,15}$/ },
  { area: 'Spain (España)', code: '+34', reg: /^\d{6,12}$/ },
  { area: 'Sri Lanka', code: '+94', reg: /^\d{6,12}$/ },
  { area: 'Sudan', code: '+249', reg: /^\d{6,15}$/ },
  { area: 'Suriname', code: '+597', reg: /^\d{6,15}$/ },
  { area: 'Svalbard and Jan Mayen', code: '+47', reg: /^\d{6,12}$/ },
  { area: 'Swaziland', code: '+268', reg: /^\d{6,15}$/ },
  {
    area: 'Sweden (Sverige)',
    code: '+46',
    reg: /^[124-7](\d{8}|\d{10}|\d{12})$/
  },
  { area: 'Switzerland (Schweiz)', code: '+41', reg: /^\d{6,12}$/ },
  { area: 'Syria', code: '+963', reg: /^\d{6,15}$/ },
  { area: 'Tajikistan', code: '+992', reg: /^\d{6,15}$/ },
  { area: 'Tanzania', code: '+255', reg: /^\d{6,15}$/ },
  { area: 'Thailand', code: '+66', reg: /^[13456789]\d{7,8}$/ },
  { area: 'Timor-Leste', code: '+670', reg: /^\d{6,15}$/ },
  { area: 'Togo', code: '+228', reg: /^\d{6,15}$/ },
  { area: 'Tokelau', code: '+690', reg: /^\d{6,15}$/ },
  { area: 'Tonga', code: '+676', reg: /^\d{6,15}$/ },
  { area: 'Trinidad and Tobago', code: '+1868', reg: /^\d{6,15}$/ },
  { area: 'Tunisia', code: '+216', reg: /^\d{6,12}$/ },
  { area: 'Turkey (Türkiye)', code: '+90', reg: /^\d{6,12}$/ },
  { area: 'Turkmenistan', code: '+993', reg: /^\d{6,15}$/ },
  { area: 'Turks and Caicos Islands', code: '+1649', reg: /^\d{6,15}$/ },
  { area: 'Tuvalu', code: '+688', reg: /^\d{6,15}$/ },
  { area: 'U.S. Virgin Islands', code: '+1340', reg: /^\d{6,15}$/ },
  { area: 'Uganda', code: '+256', reg: /^\d{6,15}$/ },
  { area: 'Ukraine (Україна)', code: '+380', reg: /^[3-79]\d{8,9}$/ },
  { area: 'United Arab Emirates', code: '+971', reg: /^\d{6,12}$/ },
  { area: 'United Kingdom', code: '+44', reg: /^[347-9](\d{8,9}|\d{11,12})$/ },
  { area: 'United States', code: '+1', reg: /^\d{10}$/ },
  { area: 'Uruguay', code: '+598', reg: /^\d{6,15}$/ },
  { area: 'Uzbekistan (Oʻzbekiston)', code: '+998', reg: /^\d{6,15}$/ },
  { area: 'Vanuatu', code: '+678', reg: /^\d{6,15}$/ },
  {
    area: 'Vatican City (Città del Vaticano)',
    code: '+39',
    reg: /^[37]\d{8,11}$/
  },
  { area: 'Venezuela', code: '+58', reg: /^\d{6,12}$/ },
  { area: 'Vietnam (Việt Nam)', code: '+84', reg: /^[1-9]\d{6,9}$/ },
  { area: 'Wallis and Futuna', code: '+681', reg: /^\d{6,15}$/ },
  { area: 'Western Sahara', code: '+212', reg: /^\d{6,12}$/ },
  { area: 'Yemen', code: '+967', reg: /^\d{6,15}$/ },
  { area: 'Zambia', code: '+260', reg: /^\d{6,15}$/ },
  { area: 'Zimbabwe', code: '+263', reg: /^\d{6,15}$/ }
]
function fun_g_sel(e) {
  const className = e.target.attributes.class.nodeValue
  let dom = null
  for (let i = 0; i < document.getElementsByClassName(className).length; i++) {
    // eslint-disable-next-line eqeqeq
    if (document.getElementsByClassName(className)[i] == e.target) {
      dom = document.getElementsByClassName(className)[i]
      break
    }
  }
  if ($(dom).closest('.component-body').hasClass('open')) {
    $(dom).closest('.component-body').removeClass('open')
  } else {
    // eslint-disable-next-line no-invalid-this
    this.fun_g_blur()
    $(dom).closest('.component-body').addClass('open')
  }
}

$(document.body).delegate('.component-body .select-component-body li', 'click', function () {
  fun_g_blur()
})

function fun_g_blur() {
  for (let i = 0; i < document.getElementsByClassName('component-body').length; i++) {
    document.getElementsByClassName('component-body')[i].classList.remove('open')
  }
}
function verify_email(email) {
  // 验证邮箱格式、并验证位数{64}@{255}
  const myMail = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
  const sp = email.split('@')
  const a64 = (sp[0]?.length || 0) <= 64
  const a255 = (sp[1]?.length || 0) <= 255
  return myMail.test(email) && a64 && a255
}
function download_path(file) {
  console.log(file)
  if (!window.Atag) {
    window.Atag = document.createElement('a')
    document.body.appendChild(window.Atag)
  }
  window.Atag.href =
    '/common/urlDownload?fileName=' + encodeURIComponent(file.name) + '&url=' + encodeURIComponent(file.url)
  window.Atag.click()
}
function newObj(obj) {
  return JSON.parse(JSON.stringify(obj))
}
// 校验身份证
async function varifyID(url, data) {
  const res = await axios.post(ajaxUrl + url, data)
  return res
}

function bytes(str) {
  let num = 0
  if (typeof str === 'string') {
    const a = str.split('')
    for (let i = 0; i < a.length; i++) {
      if (a[i].charCodeAt(0) < 299) {
        num++
      } else {
        num += 2
      }
    }
  }
  return num
}

// 验证国际手机格式
function testPhone(areaCode, phone) {
  let bool = false
  options.forEach((item) => {
    if (item.code === areaCode) {
      bool = item.reg.test(phone)
    }
  })
  return bool
}

// 动态添加dom
function setDOM(tag, parent, attr) {
  const dom = document.createElement(tag)
  if (attr && typeof attr === 'object') {
    // eslint-disable-next-line guard-for-in
    for (const key in attr) {
      dom.setAttribute(key, attr[key])
    }
  }
  parent.appendChild(dom)
  return dom
}

// 禁止鼠标连点问题，方法需要先实例；默认进来有key为false
const dbClick = {
  key: false,
  uncList: ['on', 'off', 'hasErr', 'check', 'uncList'],
  hasErr: function () {
    console.error('There is a key that cannot be modified.')
  },
  check: function (key) {
    if (this[key]) {
      return false
    }
    this.on(key)
  },
  on: function (key) {
    if (dbClick.uncList.indexOf(key) === -1) {
      dbClick[key] = true
    } else {
      dbClick.hasErr()
    }
  },
  off: function (key) {
    if (dbClick.uncList.indexOf(key) === -1) {
      dbClick[key] = false
    } else {
      dbClick.hasErr()
    }
  }
}

function debounce(fn, delay = 1000) {
  let timer = null
  return function () {
    const args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      // eslint-disable-next-line no-invalid-this
      fn.apply(this, args)
    }, delay)
  }
}

function throttle(fn, delay = 1000) {
  let timer = null
  return function (...args) {
    if (!timer) {
      timer = setTimeout(() => {
        // eslint-disable-next-line no-invalid-this
        fn.apply(this, arguments)
        timer = null
      }, delay)
    }
  }
}

// eslint-disable-next-line vue/require-name-property
export default {
  varifyID,
  ajaxUrl,
  fun_g_sel,
  fun_g_blur,
  options,
  verify_email,
  download_path,
  newObj,
  bytes,
  testPhone,
  setDOM,
  dbClick,
  debounce,
  throttle
}
</script>
